module.exports = __webpack_public_path__ + "img/3.b580a33a.jpg";